import { Injectable } from '@angular/core';
@Injectable({providedIn: 'root'})
export class DisableDateService {

  constructor() {
  }
  
  disabledStartDate = (startDate: Date, endDate: Date): boolean => {
    if (!startDate || !endDate) {
      return startDate.getTime() >= new Date().getTime();
    }
    return (startDate.getTime() >= endDate.getTime() || startDate.getTime() >= new Date().getTime());
  };

  disabledEndDate = (endDate: Date, startDate: Date): boolean => {
    if (!endDate || !startDate) {
      return endDate.getTime() >= new Date().getTime();
    }
    return (endDate.getTime() <= startDate.getTime() || endDate.getTime() >= new Date().getTime());
  };

}
